<script setup>
import countTo from "vue-count-to/src";

defineProps({
  title: {
    type: String,
    default: "",
  },
  count: {
    type: Number,
    default: 0,
  },
  prefix: {
    type: String,
    default: "",
  },
  suffix: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 3000,
  },
  decimals: {
    type: Number,
    default: 2, 
  },
});
</script>
<template>
  <div class="col-md-4 col-12 text-center">
    <div class="border-dashed border-1 border-secondary border-radius-md py-1 py-md-3 d-flex d-md-block align-items-center ">
      <h6 class="text-primary mb-0 px-3 px-md-0 fs-6 ">{{ title }}</h6>
      <h4 class="font-weight-bolder mb-0 fs-6 ">
        <span class="small">{{ prefix }}</span>
        {{ "" }}
        <countTo 
          :start-val="count" 
          :end-val="count" 
          :duration="duration"
          :decimals="decimals"
        ></countTo>
        {{ "" }}
        <span class="small">{{ suffix }}</span>
      </h4>
    </div>
  </div>
</template>

